import { _ as _extends } from './extends-a2cb9f0c.esm.js';
import * as React from 'react';
import { Provider, Menu, Divider } from 'react-native-paper';
import { A as AppAssets } from './index-3256db5b.esm.js';
import { A as AppText } from './index-6b88191c.esm.js';
import { View } from 'react-native';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';

const AppButtonMenu = _ref => {
  var _currentTheme$theme, _Assets$icons;
  let {
    mainActionLabel,
    onClickMainAction = () => {},
    onClickMenuItem = () => {},
    onMenuOpened = () => {},
    onMenuClosed = () => {},
    options,
    menuItemStyle,
    labelStyle,
    forceOpening,
    forceClosing,
    containerStyle,
    menuItemIconSize,
    anchorPosition,
    chevronColor,
    chevronSize,
    ...props
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const [visible, setVisible] = React.useState(false);
  const openMenu = () => setVisible(true);
  const closeMenu = () => setVisible(false);
  const [hovered, setHovered] = React.useState(false);
  const wrapperRef = React.useRef(null);
  React.useEffect(() => {
    openMenu();
  }, [forceOpening]);
  React.useEffect(() => {
    closeMenu();
  }, [forceClosing]);
  React.useEffect(() => {
    if (visible) onMenuOpened();else onMenuClosed();
  }, [visible]);
  React.useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        var _event$target;
        // if the target has aria-label="menu-item-button-action" then it's a menu item button and we don't want to close the menu
        if ((event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.getAttribute("aria-label")) !== "menu-item-button-action") setVisible(false); // close the menu
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef, visible]);
  const onHover = v => {
    console.log("onHover", v);
    setHovered(v);
  };
  return /*#__PURE__*/React.createElement(Provider, null, /*#__PURE__*/React.createElement(View, {
    style: containerStyle,
    ref: wrapperRef,
    onPointerEnter: onHover,
    onPointerLeave: onHover
  }, /*#__PURE__*/React.createElement(Menu, {
    anchorPosition: anchorPosition,
    style: [{
      left: 0,
      top: 27
    }, props === null || props === void 0 ? void 0 : props.style],
    visible: visible,
    onDismiss: closeMenu,
    contentStyle: {
      backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.backgroundContrastColor
    },
    anchor: /*#__PURE__*/React.createElement(AppText, _extends({
      onPress: onClickMainAction,
      isClickable: true,
      isHoverable: false,
      rightIcon: AppAssets === null || AppAssets === void 0 ? void 0 : (_Assets$icons = AppAssets.icons) === null || _Assets$icons === void 0 ? void 0 : _Assets$icons.arrow_down,
      rightIconColor: chevronColor,
      iconSize: chevronSize,
      onRightIconPress: openMenu,
      style: labelStyle
    }, props), mainActionLabel)
  }, options === null || options === void 0 ? void 0 : options.map((option, index) => {
    if (option !== null && option !== void 0 && option.isDivider) return /*#__PURE__*/React.createElement(Divider, {
      key: index
    });else return /*#__PURE__*/React.createElement(AppText, {
      accessibilityLabel: "menu-item-button-action",
      leftIcon: option === null || option === void 0 ? void 0 : option.icon,
      iconSize: menuItemIconSize,
      key: index,
      onPress: event => {
        event.stopPropagation();
        event.preventDefault();
        onClickMenuItem(option === null || option === void 0 ? void 0 : option.id);
        closeMenu();
      },
      isClickable: true,
      wrapperStyle: {
        padding: 10
      },
      style: menuItemStyle
    }, option === null || option === void 0 ? void 0 : option.label);
  }))));
};
AppButtonMenu.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppButtonMenu",
  "props": {
    "onClickMainAction": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "onClickMenuItem": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "onMenuOpened": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "onMenuClosed": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    }
  }
};

export { AppButtonMenu as A };
